module.exports = __webpack_public_path__ + "static/interior_off_left-9133636ee693850546f6eccd3eacda40.webp";